"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeasonProperty = exports.seasonPropertyDefinition = void 0;
exports.seasonPropertyDefinition = {
    view: { label: 'Season' },
    constraints: [
        {
            name: 'stencils',
            argument: ['season'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'season',
};
const isSeasonProperty = (prop) => {
    return prop.name === exports.seasonPropertyDefinition.name;
};
exports.isSeasonProperty = isSeasonProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Vhc29uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc2Vhc29uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLFFBQVEsQ0FBQztTQUNyQjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxRQUFRO0NBQ2lCLENBQUE7QUFJMUIsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLElBQWtCLEVBQTBCLEVBQUU7SUFDN0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGdDQUF3QixDQUFDLElBQUksQ0FBQTtBQUNwRCxDQUFDLENBQUE7QUFGWSxRQUFBLGdCQUFnQixvQkFFNUIifQ==